import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import TiptapEditor from "components/shared/TiptapEditor/TiptapEditor";
import { cloneDeep, isEmpty } from "lodash";
import { cleanTiptapContent, safelyParseJSON } from "helpers/common";

const ChatInput = ({ onSend, editMessage, onCancelEdit }) => {
  const [message, setMessage] = useState(null);
  const [sending, setSending] = useState(false);
  const [showToolbar, setShowToolbar] = useState(false);

  useEffect(() => {
    setMessage(safelyParseJSON(editMessage?.message));
  }, [editMessage]);

  const handleSend = () => {
    if (isEmpty(message)) return;

    let messageContents = cloneDeep(message);
    if(typeof message.json === "object") {
      messageContents.json = cleanTiptapContent(messageContents.json);
      if (isEmpty(messageContents)) return;
    }

    messageContents = JSON.stringify(messageContents);

    setSending(true);
    setShowToolbar(false);
    onSend?.(messageContents);
    setSending(false);
    setMessage(null);
  };

  const handleCancel = () => {
    setMessage(null);
    onCancelEdit?.();
  };

  const toggleToolbar = () => {
    setShowToolbar((prevState) => !prevState);
    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "instant",
      });
    }, 0);
  };

  return (
    <div className="p-2">
      <Row className="align-items-end">
        <Col lg="11">
          <TiptapEditor
            enableToolbar={showToolbar}
            value={message}
            onChange={setMessage}
            placeholder="Type a message..."
            onEnter={handleSend}
          />
        </Col>
        <Col lg="1">
          <div className="d-flex flex-column align-items-center justify-content-center gap-2 me-3">
            {editMessage && (
              <Button variant="outline-danger" onClick={handleCancel}>
                <i className="fa fa-times me-1" />
              </Button>
            )}
            <Button
              variant={showToolbar ? "primary" : "outline-primary"}
              onClick={toggleToolbar}
            >
              Aa
            </Button>
            <Button
              variant="primary"
              onClick={handleSend}
              disabled={isEmpty(message) || sending}
            >
              <i className="fa fa-paper-plane me-1" />
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ChatInput;
